import { isEmpty } from "lodash-es";
import { Button, DeleteIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import { Key } from "antd/lib/table/interface";
import { useConfirm } from "melco-shared-logic";
import { useDeactivateCoupons } from "../../hooks/coupons/useDeactivateCoupons";

type BulkActionDeactivateCouponsProps = {
    selectedRowKeys: Key[];
    setSelectedRowKeys: (keys: Key[]) => void;
    refetch?: () => Promise<any>;
};

export const BulkActionDeactivateCoupons: React.FC<
    BulkActionDeactivateCouponsProps
> = ({ selectedRowKeys, setSelectedRowKeys, refetch }) => {
    const { t } = useTranslation();

    const deactivateCoupons = useDeactivateCoupons();

    const confirmDeactivate = useConfirm(
        async () => {
            const successfullyDeactivatedIds = await deactivateCoupons(
                selectedRowKeys.map((key) => key.toString())
            );

            if (refetch) {
                refetch();
            }

            // keep items that were not deleted selected
            setSelectedRowKeys(
                selectedRowKeys.filter(
                    (id) => !successfullyDeactivatedIds.includes(id.toString())
                )
            );
        },
        {
            translationPrefix: selectedRowKeys.length > 1 ? "coupons.actions.deactivate_multiple" : "coupons.actions.deactivate",
            translationOptions: {
                count: selectedRowKeys.length,
            },

        }
    );

    if (isEmpty(selectedRowKeys)) {
        return null;
    }

    return (
        <Button
            key="bulk-download"
            icon={<DeleteIcon />}
            onClick={async () => {
                await confirmDeactivate();
            }}
        >
            {t("coupons.actions.deactivate.title")}
        </Button>
    );
};
